import React from "react";

function MovieCard({ movie, toggleFavourite, isFavourite }) {
  return (
    <div className="movie-card">

      <div className="movie-top">
        <h3>{movie.title}</h3>
        <span className="year">{movie.year}</span>
        <span className="genre">{movie.genre}</span>
      </div>

      <div className="movie-bottom">

        <div className="rating">
          ⭐ <span>{movie.rating}</span>
        </div>

        <div className="tags">
          {movie.tags.map((tag, i) => (
            <span key={i} className="tag">{tag}</span>
          ))}
        </div>

        <button
          className="fav-btn"
          onClick={() => toggleFavourite(movie)}
        >
          {isFavourite ? "❤️ Favorite" : "♡ Favorite"}
        </button>

      </div>

    </div>
  );
}

export default MovieCard;